export default __webpack_public_path__ + "static/media/acceleZ.4aba51e7.svg";